import {useState} from "react";

import {HomeRepayCreditFormOnRampValues} from "../../utils";

import HomeRepayCreditFormOnRampStep0 from "./HomeRepayCreditFormOnRampStep0";
import HomeRepayCreditFormOnRampStep1 from "./HomeRepayCreditFormOnRampStep1";

interface HomeRepayCreditFormOnRampProps {
  onCloseModal: () => void;
  handleBack: () => void;
}

function HomeRepayCreditFormOnRamp(
  {
    onCloseModal,
    handleBack,
  }:HomeRepayCreditFormOnRampProps) {

  const [formData, setFormData] = useState<HomeRepayCreditFormOnRampValues>({
    amount: undefined,
    fiatCurrency: "usd",
    tokens: ["USDC", "BASE"],
    accountNumber: "",
    routingNumber: "",
    companyAddress: "",
    country: "",
    province: "",
    city: "",
    postalCode: "",
  })

  const [currentStep, setCurrentStep] = useState(0)

  const handleNextStep = (newFormData: HomeRepayCreditFormOnRampValues) => {
    setFormData(prev => ({...prev, ...newFormData}))

    if (currentStep === steps.length - 1) {
      console.log(newFormData)
      alert(JSON.stringify(newFormData, null, 2))
    } else {
      setCurrentStep(prev => prev + 1)
    }
  }

  const handlePrevStep = (newFormData: HomeRepayCreditFormOnRampValues) => {
    setFormData(prev => ({...prev, ...newFormData}))
    setCurrentStep(prev => prev - 1)
  }

  const steps = [
    <HomeRepayCreditFormOnRampStep0
      data={formData}
      next={handleNextStep}
      handleBack={handleBack}
      onCloseModal={onCloseModal}
    />,

    <HomeRepayCreditFormOnRampStep1
      data={formData}
      prev={handlePrevStep}
      onCloseModal={onCloseModal}
    />,
  ]

  return (
    <>
      {steps[currentStep]}
    </>
  );
}

export default HomeRepayCreditFormOnRamp;